import { useRef } from "react";
import styles from "./SectionView.module.scss";
import { defaultDateDisplay, truncateString } from "../../../helpers";
import useSectionView from "./useSectionView";
import { MobilePrint } from "./MobilePrint";

export const SectionView = ({
  section_id,
  closePrint = () => {},
  isDocket = false,
  invalidateQueries = () => {},
}) => {
  const sectionPrintComponent = useRef(null);

  const {
    isMobile,
    business_name,
    address,
    sectionDetails,
    paperSize,
    receipt_footer_title,
    receipt_footer_description,
    clearAfterPrint,
  } = useSectionView({
    section_id,
    sectionPrintComponent,
    hiddenId: "section-hidden-section",
    isDocket,
    closePrint,
    invalidateQueries,
  });

  return (
    <>
      <div
        id="section-hidden-section"
        ref={sectionPrintComponent}
        style={{ display: "none", maxWidth: `${paperSize}px` }}
        className={styles.sectionView}
      >
        <div className="text-center mb-2">
          <h6 style={{ fontSize: "30px" }}>
            {truncateString(business_name, 150)}
          </h6>
          <h6 className="dark--text">{truncateString(address, 150)}</h6>
        </div>

        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Queue Number:</h6>
          <h4 className="mb-0">
            {sectionDetails?.order?.queue_number || "N/A"}
          </h4>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Order Date:</h6>
          <h6>{defaultDateDisplay(sectionDetails?.created_at)}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Order For:</h6>
          <h6>{sectionDetails?.section?.name}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Order ID:</h6>
          <h6>{sectionDetails?.order?.id}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Table:</h6>
          <h6>{sectionDetails?.order?.table?.name || "N/A"}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Order Type:</h6>
          <h6>{sectionDetails?.order?.order_type?.replace("_", " ")}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Cashier Name:</h6>
          <h6>{sectionDetails?.order?.initiator?.first_name || "N/A"}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Customer Name:</h6>
          <h6>{sectionDetails?.order?.customer?.full_name || "N/A"}</h6>
        </div>
        <div className={styles.sectionView__item}>
          <h6 className="small-text-size">Order:</h6>
          <h6>
            {sectionDetails?.docket_items?.map((item, index) => (
              <span key={item?.id}>
                {" "}
                {item?.quantity} x{" "}
                <span className="dark--text">
                  {item?.cart_item?.cart_item_name}
                </span>
                {index === sectionDetails?.docket_items?.length - 1 ? "" : ","}
              </span>
            ))}
          </h6>
        </div>

        <div>
          <h6 className="small-text-size">Notes:</h6>
          <h6>{sectionDetails?.order?.notes || "N/A"}</h6>
        </div>

        {receipt_footer_title ? (
          <h4 className="text-center mt-4">{receipt_footer_title}</h4>
        ) : null}
        {receipt_footer_description ? (
          <h5 className="text-center mt-1">{receipt_footer_description}</h5>
        ) : null}
      </div>

      {isMobile && sectionDetails ? (
        <MobilePrint
          address={address}
          business_name={business_name}
          sectionDetails={sectionDetails}
          clearAfterPrint={clearAfterPrint}
        />
      ) : null}
    </>
  );
};
